import { getAuth } from "../../contexts/authStore";
import { getAppsyncUrl } from "../authenticate";


export async function putUser(userId: string, accountType: string, name: string, email?: string, phone?: string, created?: string, archived?: string, primarySchedule?: string, lastLoggedIn?: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putUser(userId: ${JSON.stringify(userId)}, accountType: ${JSON.stringify(accountType)}, name: ${JSON.stringify(name)}, email: ${email ? JSON.stringify(email) : '""'}, phone: ${phone ? JSON.stringify(phone) : '""'}
                ${created ? ", created: " + JSON.stringify(created) : ''}${archived ? ", archived: " + JSON.stringify(archived) : ''}${primarySchedule ? ", primarySchedule: " + JSON.stringify(primarySchedule) : ''}${lastLoggedIn ? ", lastLoggedIn: " + JSON.stringify(lastLoggedIn) : ''})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putUser)
            })
        })
    }
}

export async function putUserNotificationSettings(userId: string, smsNotifications: boolean, emailNotifications: boolean, shiftChanges: boolean, shiftReminders: boolean,
    submitScheduleNotification: boolean, approvalNotifications: boolean, passwordChange: boolean
) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putUserNotificationSettings(userId: ${JSON.stringify(userId)}, smsNotifications: ${smsNotifications ? JSON.stringify(smsNotifications) : JSON.stringify(false)},
                emailNotifications: ${emailNotifications ? JSON.stringify(emailNotifications) : JSON.stringify(false)},
                shiftChanges: ${shiftChanges ? JSON.stringify(shiftChanges) : JSON.stringify(false)},
                shiftReminders: ${shiftReminders ? JSON.stringify(shiftReminders) : JSON.stringify(false)},
                submitScheduleNotification: ${submitScheduleNotification ? JSON.stringify(submitScheduleNotification) : JSON.stringify(false)},
                approvalsNotification: ${approvalNotifications ? JSON.stringify(approvalNotifications) : JSON.stringify(false)},
                passwordChange: ${passwordChange ? JSON.stringify(passwordChange) : JSON.stringify(false)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putUserNotificationSettings)
            })
        })
    }
}


export async function getUser(userId: string) {
    if (getAuth().userId) {
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                body: JSON.stringify({
                    query: `query Query {
                getUser(userId: ${JSON.stringify(userId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getUser)
            })
        })
    }
}

export async function getUserNotificationSettings(userId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getUserNotificationSettings(userId: ${JSON.stringify(userId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getUserNotificationSettings)
            })
        })
    }
}

export async function deleteUserNotificationSettings(userId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                deleteUserNotificationSettings(userId: ${JSON.stringify(userId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.deleteUserNotificationSettings)
            })
        })
    }
}